import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { deepExtend, executeOnSingleOrMultiple } from "../../../Utils/Utils";
import { AnimatableColor } from "../AnimatableColor";
import { Collisions } from "./Collisions/Collisions";
import { Move } from "./Move/Move";
import { Opacity } from "./Opacity/Opacity";
import { ParticlesBounce } from "./Bounce/ParticlesBounce";
import { ParticlesNumber } from "./Number/ParticlesNumber";
import { Shadow } from "./Shadow";
import { Shape } from "./Shape/Shape";
import { Size } from "./Size/Size";
import { Stroke } from "./Stroke";
import { ZIndex } from "./ZIndex/ZIndex";
export var ParticlesOptions = /*#__PURE__*/function () {
  function ParticlesOptions(engine, container) {
    _classCallCheck(this, ParticlesOptions);

    this._engine = engine;
    this._container = container;
    this.bounce = new ParticlesBounce();
    this.collisions = new Collisions();
    this.color = new AnimatableColor();
    this.color.value = "#fff";
    this.groups = {};
    this.move = new Move();
    this.number = new ParticlesNumber();
    this.opacity = new Opacity();
    this.reduceDuplicates = false;
    this.shadow = new Shadow();
    this.shape = new Shape();
    this.size = new Size();
    this.stroke = new Stroke();
    this.zIndex = new ZIndex();
  }

  _createClass(ParticlesOptions, [{
    key: "load",
    value: function load(data) {
      var _data$move$collisions, _data$move, _data$move2, _data$stroke, _data$shape;

      if (!data) {
        return;
      }

      this.bounce.load(data.bounce);
      this.color.load(AnimatableColor.create(this.color, data.color));

      if (data.groups !== undefined) {
        for (var group in data.groups) {
          var item = data.groups[group];

          if (item !== undefined) {
            var _this$groups$group;

            this.groups[group] = deepExtend((_this$groups$group = this.groups[group]) !== null && _this$groups$group !== void 0 ? _this$groups$group : {}, item);
          }
        }
      }

      this.move.load(data.move);
      this.number.load(data.number);
      this.opacity.load(data.opacity);

      if (data.reduceDuplicates !== undefined) {
        this.reduceDuplicates = data.reduceDuplicates;
      }

      this.shape.load(data.shape);
      this.size.load(data.size);
      this.shadow.load(data.shadow);
      this.zIndex.load(data.zIndex);
      var collisions = (_data$move$collisions = (_data$move = data.move) === null || _data$move === void 0 ? void 0 : _data$move.collisions) !== null && _data$move$collisions !== void 0 ? _data$move$collisions : (_data$move2 = data.move) === null || _data$move2 === void 0 ? void 0 : _data$move2.bounce;

      if (collisions !== undefined) {
        this.collisions.enable = collisions;
      }

      this.collisions.load(data.collisions);

      if (data.interactivity !== undefined) {
        this.interactivity = deepExtend({}, data.interactivity);
      }

      var strokeToLoad = (_data$stroke = data.stroke) !== null && _data$stroke !== void 0 ? _data$stroke : (_data$shape = data.shape) === null || _data$shape === void 0 ? void 0 : _data$shape.stroke;

      if (strokeToLoad) {
        this.stroke = executeOnSingleOrMultiple(strokeToLoad, function (t) {
          var tmp = new Stroke();
          tmp.load(t);
          return tmp;
        });
      }

      if (this._container) {
        var updaters = this._engine.plugins.updaters.get(this._container);

        if (updaters) {
          var _iterator = _createForOfIteratorHelper(updaters),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var updater = _step.value;

              if (updater.loadOptions) {
                updater.loadOptions(this, data);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }

        var interactors = this._engine.plugins.interactors.get(this._container);

        if (interactors) {
          var _iterator2 = _createForOfIteratorHelper(interactors),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var interactor = _step2.value;

              if (interactor.loadParticlesOptions) {
                interactor.loadParticlesOptions(this, data);
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }
    }
  }]);

  return ParticlesOptions;
}();